import { Suspense, lazy, Component } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import Footer from './components/Footer'
import NavBar from './components/NavBar'
import { useVisitorTracking } from './hooks/useVisitorTracking'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Home = lazy(() => import('./components/Home'))
const Skills = lazy(() => import('./components/Skills'))
const Projects = lazy(() => import('./components/Projects'))
const Contact = lazy(() => import('./components/Contact'))
const NotFound = lazy(() => import('./components/NotFound'))
const Blog = lazy(() => import('./components/Blog'))
const CV = lazy(() => import('./components/CV'))
const Analytics = lazy(() => import('./components/Analytics'))

const ErrorFallback = () => (
  <div className="min-h-screen bg-black text-white flex items-center justify-center text-center p-10">
    <div>
      <h1 className="text-4xl font-bold mb-4">Something went wrong</h1>
      <p className="text-gray-400 mb-6">An unexpected error occurred. Please refresh the page.</p>
      <button
        onClick={() => window.location.reload()}
        className="bg-gradient-to-b from-cyan-500 to-blue-500 text-white px-6 py-3 rounded-md hover:scale-110 duration-300"
      >
        Refresh Page
      </button>
    </div>
  </div>
)

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  render() {
    if (this.state.hasError) return this.props.fallback
    return this.props.children
  }
}

function VisitorTracker() {
  useVisitorTracking()
  return null
}

function App() {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Router>
        <VisitorTracker />
        <NavBar />
        <Suspense
          fallback={
            <div className="min-h-screen bg-black text-white flex items-center justify-center">
              <div className="animate-spin h-10 w-10 border-4 border-cyan-500 border-t-transparent rounded-full" />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <ToastContainer position="bottom-right" theme="dark" />
      </Router>
    </ErrorBoundary>
  )
}

export default App
